"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.simpleRichTextEditorModules = exports.richTextEditorModules = void 0;

var _immutable = require("immutable");

// For use with RequireAsync to load the RichTextExitor.
//
// mixins: [
//   RequireAsync([
//     {
//       names: RichTextEditorModules
//       callback: 'update'
//     }
//   ])
// ]
var commonModules = (0, _immutable.List)(['hubspot.customerdata.rte.config.RichTextEditorDefaultConfigurations', 'hubspot.customerdata.rte.state.RichTextEditorContentMediator']);
var richTextEditorModules = commonModules.push('hubspot.customerdata.rte.components.RichTextEditor').toSeq();
exports.richTextEditorModules = richTextEditorModules;
var simpleRichTextEditorModules = commonModules.push('hubspot.customerdata.rte.components.SimpleRichTextEditor').toSeq();
exports.simpleRichTextEditorModules = simpleRichTextEditorModules;